// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28xps","label":"styles_label__14FOJ"};